import { render } from "./PeriodicityList.vue?vue&type=template&id=1980d6e2&scoped=true"
import script from "./PeriodicityList.vue?vue&type=script&lang=js"
export * from "./PeriodicityList.vue?vue&type=script&lang=js"

import "./PeriodicityList.vue?vue&type=style&index=0&id=1980d6e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1980d6e2"]])

export default __exports__